
<style lang="scss" scoped>
  input {
    &::placeholder {
      color: rgba($color: #828393, $alpha: 0.6);
    }
  }
  .withdraw-page {
    min-height: 100vh;
    background-color: #f8f8fb;
    padding-top: 52px;
    .alipay-msg {
      margin: 0 auto;
      padding: 0 32px;
      display: flex;
      align-items: center;
      width: 686px;
      height: 104px;
      background-color: #F3F3F8;
      box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.03);
      border-radius: 8px 8px 0 0;
      color: #828393;
      font-size: 28px;
      .msg-l {
        flex: 1;
        text-align: left;
      }
      .msg-r {
        flex: 1;
        text-align: right;
      }
    }
    .mount-container {
      width: 684px;
      margin: 0 auto;
      padding: 64px 32px 0;
      background-color: #fff;
      box-shadow: 0px 8px px rgba(0, 0, 0, 0.03);
      border-radius: 0 0 8px 8px;
      .amount-label {
        // padding: 64px 0 0 32px;
        display: flex;
        align-items: center;
        .label-title {
          flex: 1;
          text-align: left;
          font-size: 34px;
          color: #2a2a30;
          font-weight: 500;
        }
        .withdraw-all {
          flex: 1;
          width: 150px;
          font-size: 24px;
          text-align: right;
          color: #2a2a30;
        }
      }
      .amount-form {
        background-color: #fff;
        padding-top: 48px;
        p {
          height: 90px;
          line-height: 90px;
          font-size: 28px;
          margin: 0 auto;
          background-color: #fff;
          display: flex;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
          .label {
            width: 40px;
            display: inline-block;
            color: #1d1d1d;
            font-size: 58px;
            font-weight: 500;
          }
          .code-label {
            width: 150px;
            font-size: 28px;
            color: #333;
          }
          input {
            height: 100%;
            width: 480px;
            display: inline-block;
            text-indent: 0;
            background: transparent;
            border: 0 none;
            resize: none;
            outline: none;
            padding: 0;
            -webkit-appearance: none;
            line-height: normal;
            padding-left: 20px;
            font-size: 58px;
            font-weight: 500;
            color: #1d1d1d;
          }
        }
      }
      .amount-tip {
        display: flex;
        font-size: 24px;
        height: 100px;
        align-items: center;
        color: #828393;
        .warning-msg {
          flex: 1;
          color: #FF5572;
        }
        .common-msg {
          flex: 1;
        }
        .limit-msg {
          flex: 1;
          text-align: right;
        }
      }
    }

    .code-form {
      background-color: #fff;
      width: 684px;
      height: 110px;
      margin: 32px auto;
      padding: 0 32px;
      box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.03);
      border-radius: 8px;

      p {
        height: 110px;
        line-height: 110px;
        font-size: 28px;
        display: flex;
        .label {
          width: 40px;
          display: inline-block;
          color: #2a2a30;
          font-size: 28px;
        }
        .code-label {
          width: 150px;
          font-size: 28px;
          color: #333;
        }
        input {
          height: 100%;
          width: 200px;
          flex: 1;
          display: inline-block;
          text-indent: 0;
          background: transparent;
          border: 0 none;
          resize: none;
          outline: none;
          padding: 0;
          -webkit-appearance: none;
          line-height: normal;
          padding-left: 20px;
          font-size: 58px;
          color: #1d1d1d;
        }
        input.code-input {
          height: 105px;
          padding-top: 7px;
          // width: 200px;
          font-size: 28px;
          color: #2a2a30;
        }
        .withdraw-all {
          // flex: 1;
          width: 200px;
          font-size: 24px;
          text-align: right;
          color: #2a2a30;
        }
        .code-gray {
          color: #828393;
        }
      }
    }
    .form-margin {
      padding-top: 40px;
    }
    .error-area {
      text-align: center;
      width: 702px;
      height: 60px;
      margin: 0 auto;
      line-height: 60px;
      color: #ff1c00;
      font-size: 24px;
    }
    .confirm-button {
      position: fixed;
      bottom: 80px;
      left: 50%;
      transform: translateX(-50%);
      width: 686px;
      height: 88px;
      font-size: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #2a2a30;
      color: #fff;
      &.black {
        color: #fff;
      }
      &.gray {
        background-color: rgba(231, 231, 240, 0.6);
        color: #fff;
      }
    }
  }
</style>

<template>
  <div class="withdraw-page">
    <div class="alipay-msg">
      <div class="msg-l">收款支付宝</div>
      <div class="msg-r">{{baseInfo.alipayAccount}}</div>
    </div>
    <div class="mount-container">
      <div class="amount-label">
        <div class="label-title">提现金额（元）</div>
        <div class="withdraw-all" @click.prevent="withdrawAll">全部提现</div>
      </div>
      <div class="amount-form form-margin">
        <p><span class="label">¥</span><input @input="resetErrorMsg" type="number" v-model="amountC"/></p>
      </div>
      <p class="amount-tip">
        <template>
          <span v-if="overAmount" class="warning-msg">提现金额超出限制</span>
          <span v-else-if="!bigThanOne" class="warning-msg">提现金额不得小于1元</span>
          <span v-else-if="singleOnceOverMax" class="warning-msg">单笔提现不得大于5万</span>
          <span v-else class="common-msg">可提现 ¥{{baseInfo.singleDayWithdrawRest | transMoney}}</span>
        </template>
        <span class="limit-msg">每日提现上限 ¥{{baseInfo.singleDayWithdrawMax | transMoney}}</span>
      </p>
    </div>

    <div class="code-form">
      <p>
        <span class="code-label">手机验证码</span>
        <input v-model="verificationCode" placeholder="请输入验证码" class="code-input" @input="resetErrorMsg">
        <span v-if="!showRemainTime" class="withdraw-all" @click="getCodeAgain()">获取验证码</span>
        <span v-else class="withdraw-all code-gray">重新获取({{remainTime}})</span>
      </p>
    </div>
    <div class="error-area">
      <!-- <span >{{errorMessage}}</span> -->
    </div>
    <p class="confirm-button" v-bind:class="[canConfirm ? 'black' : 'gray']" @click="submitConfirm()">
      <span>提现</span></p>
  </div>
</template>

<script>
import { formatMoney } from '../../common/utils'
import { withdraw, fetchWithdrawSms } from '../../common/api/wallet'
import { Toast, Indicator } from 'mint-ui';

export default {
  name: 'walletWithdraw',
  data () {
    return {
      amount: '', // 用户输入金额, 用字符串来解决bug问题
      verificationCode: '',
      remainTime: 0,
      codeError: false,
      errorMessage: '',
      sendMessage: '',
    }
  },
  computed: {
    overAmount () {
      return Math.floor(Number(this.amount) * 100) > this.baseInfo.singleDayWithdrawRest
    },
    singleOnceOverMax () {
      return Number(this.amountC) > 50000
    },
    bigThanOne () {
      return this.amountC === '' || Number(this.amountC) >= 1
    },
    canConfirm () {
      return !this.singleOnceOverMax && this.bigThanOne && Number(this.amount) >= 1 && this.amount && Math.floor(Number(this.amount) * 100) <= this.baseInfo.singleDayWithdrawRest && this.verificationCode !== ''
    },
    showRemainTime () {
      return this.remainTime > 0
    },
    baseInfo () {
      return this.$store.state.wallet.mainInfo ? this.$store.state.wallet.mainInfo.data : {}
    },
    amountC: {
      get: function () {
        return this.amount
      },
      set: function (val) {
        if (val.indexOf('.') > 0 && (val.length - val.indexOf('.')) > 3) {
          console.log(val.substr(0, val.length - 1))
          this.amount = ''
          this.amount = val.substr(0, val.length - 1)
        } else {
          this.amount = val
        }
      }
    }

  },
  watch: {},
  methods: {
    getWalletInfo () {
      this.$store.dispatch('GET_WALLET_MAIN_INFO', {})
    },
    submitConfirm () {
      if (!this.canConfirm) return
      Indicator.open({
        spinnerType: 'snake'
      })
      return withdraw({ verificationCode: this.verificationCode, amount: Number(this.amount) * 100 })
        .then(result => {
          if (result.errorCode === 0) {
            this.$router.replace({ name: 'withdrawSuccess' })
          } else {
            this.sendMessage = ''
            this.errorMessage = result.errorMsg
            Toast(result.errorMsg)
          }
        }).finally(() => {
          this.amount = '' //  处理一瞬间闪过金额超出限制问题
          this.getWalletInfo()
          Indicator.close()
        })
    },
    getCodeAgain () {
      if (this.showRemainTime) return
      // 获取手机验证码
      fetchWithdrawSms()
        .then(result => {
          if (result.errorCode === 0) {
            this.errorMessage = ''
            this.sendMessage = result.prompt
            Toast(result.prompt)

            this.remainTime = 50
            let tiemInterval = setInterval(() => {
              if (this.remainTime <= 0) {
                this.sendMessage = ''
                clearInterval(tiemInterval)
                return
              }
              this.remainTime--
            }, 1000)
          }
        })
    },
    withdrawAll () {
      this.amountC = (this.baseInfo.singleDayWithdrawRest / 100).toString()
    },
    resetErrorMsg () {
      this.errorMessage = ''
    }
  },
  filters: {
    transMoney (value) {
      return value ? formatMoney(value) : '0.00'
    }
  },
  created () {
    // disptch ...
    this.getWalletInfo()
  }
}
</script>
